import { Navigate } from "react-router-dom"
import Login from "../users/Login"

const ProtectedRoutes = (({isLoggedIn, children}) => {
    if(!isLoggedIn){
        return <Navigate to="/login" replace />;
    }
    return children
})
export default ProtectedRoutes